const { parseCoordinates } = require('./coordinate-helper')
const { DEFAULT_LOCATION_ID_HIERARCHY } = require('./get-region-level-sub-tiers')
const getLocationIdError = require('./get-location-id-error')

const validateOtherDocs = (locationDoc, locationIdHierarchy, requiredLocationAdditionalFieldsForBulkImport = []) => {
  const errors = []

  // validate additionalData doc
  const missingADFields = requiredLocationAdditionalFieldsForBulkImport.find(field => !locationDoc.additionalData[field])
  if (missingADFields) errors.push(`${missingADFields} not found in additionalData`)

  // partial entry for location longitude & latitude not allowed
  const coordinates = parseCoordinates(locationDoc.additionalData.latLng)
  if ((!coordinates.lat && coordinates.long) || (coordinates.lat && !coordinates.long)) {
    errors.push(`Both longitude and latitude field is required for coordinates`)
  }

  // validate locations doc
  const missingLocationField = locationIdHierarchy.find(field => !locationDoc.location[field])
  if (missingLocationField) errors.push(`${missingLocationField} not found in location`)
  return errors
}

const validateProgramsDoc = (locationDoc, funderList) => {
  const errors = []
  // validate services
  if (!locationDoc.services.length) errors.push('At least one service is required')

  // validate programs, funders and implementing partners
  if (!locationDoc.programs.length) {
    errors.push('At least one program is required')
  } else {
    locationDoc.programs.forEach(programDoc => {
      programDoc.services.forEach(service => {
        const funder = funderList.find(funder => funder._id === service.funderId)
        if (!funder) return errors.push(`Assigned Funder for ${service.id} not found in system`)
        const newImplementingPartner = service.implementingPartnerId
        const findImplementingPartner = funder.programs[programDoc.id] &&
          funder.programs[programDoc.id].implementingPartners.find(ip => ip._id === newImplementingPartner)
        if (!findImplementingPartner) errors.push(`Implementing partner for ${service.id} does not match ${funder._id}`)
      })
    })
  }
  return errors
}

exports.sanitizeDoc = async (existingLocationDocs, locationDoc, funderList, locationIdHierarchy = DEFAULT_LOCATION_ID_HIERARCHY, requiredLocationAdditionalFieldsForBulkImport = []) => {
  let errors = {
    row: locationDoc.row
  }

  // return fullName for debugging purposes
  errors.fullName = !locationDoc.fullName ? 'Name is required' : locationDoc.fullName

  // validate services, programs, funders and implementing partners
  const programErrors = validateProgramsDoc(locationDoc, funderList)
  const otherDocsErrors = validateOtherDocs(locationDoc, locationIdHierarchy, requiredLocationAdditionalFieldsForBulkImport)
  const lgaErrors = await lgaChanges(existingLocationDocs, locationDoc)
  const idErrors = newLocationIdErrors(existingLocationDocs, locationDoc)
  const errorDocs = programErrors.concat(otherDocsErrors, lgaErrors || [], idErrors)

  delete locationDoc.row
  return {
    ...errors,
    errorDoc: errorDocs || [],
    changes: locationDoc
  }
}

// Only ids that don't exist yet are checked, so existing locations stay editable.
const newLocationIdErrors = (existingLocationDocs, doc) => {
  const idError = getLocationIdError(doc._id)
  if (!idError || existingLocationDocs.find(location => location._id === doc._id)) return []
  return [idError]
}

const lgaChanges = async (existingLocationDocs, doc) => {
  const locationId = doc._id
  const errors = []
  // validate new doc against existing doc
  if (locationId) {
    const currentLocation = existingLocationDocs.find(location => location._id === locationId)
    if (currentLocation) {
      const lgaChange = currentLocation.location.lga === doc.location.lga
      if (!lgaChange) {
        errors.push('LGA can not be changed for a location')
        return errors
      }
    }
  }
}

exports.addLocationOwnership = (doc, existingDoc, userOrgId) => {
  if (!existingDoc) {
    doc.ownedBy = [userOrgId]
    doc.organisationAccess = []
    return
  }

  doc.ownedBy = existingDoc.ownedBy || []
  doc.organisationAccess = existingDoc.organisationAccess || []
}
